
define('text!modules/reporting/campaigns/dataExport/manage/templates/manage.html',[],function () { return '<div class="header"></div>\n<div class="clear-fix"></div>\n<div class="grid-holder"></div>\n<div class="clear-fix"></div>\n';});

